document.addEventListener('DOMContentLoaded', function () {
    // Select All Checkbox Functionality
    document.getElementById('wizardSelectAll')?.addEventListener('change', function (e) {
        const checkboxes = document.querySelectorAll('.wizard-table input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.checked = e.target.checked;
            toggleRowActiveClass(checkbox); // Add/remove active class when checkbox is checked/unchecked
        });
        updateSelectedCountW();
        updateSelectedIdsW();
        updateButtonW();
    });

    // Individual Checkboxes Change Event
    document.querySelectorAll('.wizard-table input[type="checkbox"]').forEach(checkbox => {
        checkbox.addEventListener('change', function () {
            toggleRowActiveClass(this); // Add/remove active class for row
            updateSelectedCountW();
            updateSelectedIdsW();
            updateButtonW();
        });
    });

    // Function to toggle active class on row
    function toggleRowActiveClass(checkbox) {
        const row = checkbox.closest('tr'); // Get the row
        if (checkbox.checked) {
            row.classList.add('active'); // Add active class if checked
        } else {
            row.classList.remove('active'); // Remove active class if unchecked
        }
    }

    // Function to update the count of selected items
    function updateSelectedCountW() {
        const checkboxes = document.querySelectorAll('.wizard-table .checkbox:checked');
        const selectedCount = checkboxes.length;
        const selectedCountText = `${selectedCount} Contact Selected`; // Update this text as needed

        // Update the displayed selected count
        const wizard_selected_count = document.getElementById('wizard-selected-count')
        if (wizard_selected_count) {
            wizard_selected_count.textContent = selectedCountText;
        } else {

        }
    }

    // Function to update button state
    function updateButtonW() {
        const checkboxes = document.querySelectorAll('.wizard-table .checkbox:checked');
        const selectedCount = checkboxes.length;
    
        // Get the element
        const addSelectedCountElement = document.getElementById('add_selected_count');
    
        // Check if the element exists before accessing its parent
        if (!addSelectedCountElement) {
            return;
        }
    
        const parentElement = addSelectedCountElement.parentElement; // Get parent
    
        if (selectedCount > 0) {
            addSelectedCountElement.textContent = `(${selectedCount})`; // Show count if > 0
            parentElement.classList.add("active"); // Add 'active' class to parent
        } else {
            addSelectedCountElement.textContent = ""; // Keep empty if count is 0
            parentElement.classList.remove("active"); // Remove 'active' class from parent
        }
    }
    // Function to get the IDs of selected rows
    function updateSelectedIdsW() {
        const selectedIds = [];
        const checkboxes = document.querySelectorAll('.wizard-table .checkbox:checked');

        checkboxes.forEach(checkbox => {
            const row = checkbox.closest('tr');
            const rowId = row.getAttribute('data-id');
            selectedIds.push(rowId);
        });

        return selectedIds;
    }

    // Expose the function globally
    window.closeActionRow = function() {
        const checkboxes = document.querySelectorAll('.wizard-table input[type="checkbox"]');

        // Uncheck all checkboxes and remove active class from rows
        checkboxes.forEach(checkbox => {
            checkbox.checked = false;
            toggleRowActiveClass(checkbox);
        });
    };

    // Expose the function globally
    window.getCheckedIdsW = function() {
        return updateSelectedIdsW();
    };

    // Ajax işlemi tamamlandı (başarı ya da hata) fark etmeksizin
    document.addEventListener("ajax:complete", function() {
        updateSelectedCountW();
        updateSelectedIdsW();
        updateButtonW();

        document.getElementById('wizardSelectAll')?.addEventListener('change', function (e) {
            const checkboxes = document.querySelectorAll('.wizard-table input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.checked = e.target.checked;
                toggleRowActiveClass(checkbox); // Add/remove active class when checkbox is checked/unchecked
            });
            updateSelectedCountW();
            updateSelectedIdsW();
            updateButtonW();
        });

        document.querySelectorAll('.wizard-table input[type="checkbox"]').forEach(checkbox => {
            checkbox.addEventListener('change', function () {
                toggleRowActiveClass(this); // Add/remove active class for row
                updateSelectedCountW();
                updateSelectedIdsW();
                updateButtonW();
            });
            toggleRowActiveClass(checkbox); // Yüklenen checkbox'lar için aktif class'ı kontrol et
        });
    });
});
